import React from "react";
import PropTypes from "prop-types";
import HelpForm from "../../components/help-form";
import ContactInfo from "../../components/contact-info";
import ContactData from "../../data/contact.json";

const HelpContainer = ({ contRef }) => {
    return (
        <section className="contact-section section-py" ref={contRef}>
            <div className="container">
                <div className="row mb-n7">
                    <div className="col-xl-6 col-lg-6 mb-7">
                        <div className="contact-title-section">
                            <h3 className="title g-color">
                                Feel free to ask any questions
                            </h3>
                            <p className="b-color">
                                Search our FAQs for answers to anything you
                                might be wondering
                                <br className="d-none d-xl-block" />
                            </p>
                        </div>

                        <HelpForm />
                    </div>

                    <div className="col-xl-5 col-lg-6 mb-7 offset-xl-1">
                        <div className="contact-address text-center">
                            {ContactData &&
                                ContactData.map((single, key) => {
                                    return (
                                        <ContactInfo key={key} data={single} />
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

HelpContainer.propTypes = {
    contRef: PropTypes.any,
};

export default HelpContainer;
